import { PrettyColumn, ClinicExtra } from '@/types/Api';
import groupBy from 'lodash/groupBy';
import { getIdentifierColumnsFromTemplateString } from '@/utils/patient';
import { RichSelectMenuItem } from '@/types/Ui';
import {
  addHeadersAndDividersToRichSelectMenuItemsClinic,
} from './richSelectMenuItems';

export function getIdentifierColumnsFromColumnsAndTemplate(
  columns: PrettyColumn[],
  template?: string
) {
  let result = columns.filter((c: PrettyColumn) => {
    return c.tags.some((t) => t.name === 'display_identifier');
  });
  if (result.length === 0) {
    if (template) {
      const identifierColumns =
        getIdentifierColumnsFromTemplateString(template);
      result = identifierColumns.map((ic) => {
        const c = columns.find((c) => c.patientAttributesKey === ic);
        if (c === undefined) {
          throw new Error(`Could not find identifier column ${ic}`);
        }
        return c;
      });
    } else {
      result = columns.slice(0, 1);
    }
  }
  return result;
}

export function getIdentifierColumnsFromClinic(clinic: ClinicExtra) {
  return getIdentifierColumnsFromColumnsAndTemplate(
    clinic.piiColumns,
    clinic.piiFormat?.identifier_template
  );
}

export function clinicOptionsGroupedByCompany(
  clinics: ClinicExtra[],
  prettyName: keyof ClinicExtra = 'prettyName',
  id: keyof ClinicExtra = '_id'
): RichSelectMenuItem[] {
  const groupedClinics = groupBy(clinics, (c) => c.company?._id ?? 'No primary company');
  const companyKeys = Object.keys(groupedClinics).sort((a, b) => {
    if (a === 'No primary company') return 1;
    if (b === 'No primary company') return -1;
    return a.localeCompare(b);
  });

  let results: RichSelectMenuItem[] = [];
  for (const company of companyKeys) {
    const clinics = groupedClinics[company];
    const section: RichSelectMenuItem[] = clinics.map((clinic) => ({
      company: clinic.company?.prettyName ?? 'No primary company',
      title: clinic[prettyName] as string,
      key: clinic[id] as string,
    }));
    section.sort((a, b) => a.title.localeCompare(b.title));
    results = [...results, ...section];
  }

  return addHeadersAndDividersToRichSelectMenuItemsClinic(results);
}
